import { apiClient } from "../config";

async function userProfileSettings(id: any) {
  const queryString = id ? `?user_id=${id}` : "";
  const res = await apiClient.get(`/admin/users/profile/settings${queryString}`);
  return res.data;
}

export default userProfileSettings;
